// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"db9bb67f","914":"40ab9d16"}[chunkId] + ".chunk.css";
};